import React from 'react';
import JsonEditor from '~/components/JsonEditor';
import { useGlobalState } from '~/context/GlobalStateContext';

export const DataEditor: React.FC = () => {
  const { generalState, setGeneralState } = useGlobalState();

  const setData = React.useCallback(
    (value: string) => {
      const newState = {
        ...generalState,
        data: value,
      };
      setGeneralState(newState);
    },
    [generalState.data],
  );

  return (
    <JsonEditor id='template' code={generalState.data} setCode={setData} />
  );
};
